@for (ind of logIndexes; track ind) {
  <ng-container *ngIf="log[ind] as value">
    @if (value?.length === 3) {
        <!-- deleted data = [oldValue, 0, 0]-->
      <span class="ag-change-log-detail--old-value">{{value[0] | lookupDescriptionText: guestEventsLookup}}</span> was removed.
    }
    @if (value?.length === 1) {
      <!-- added data = [newValue]-->
      <span class="ag-change-log-detail--new-value">{{value[0] | lookupDescriptionText: guestEventsLookup}}</span> was added.
    }
    @if (value?.length === 2) {
      <!-- updated data = [oldValue, newValue]-->
      <span class="ag-change-log-detail--old-value">{{value[0] | lookupDescriptionText: guestEventsLookup}}</span> was updated to
      <span class="ag-change-log-detail--new-value">{{value[1] | lookupDescriptionText: guestEventsLookup}}</span>.
    }
  </ng-container>
}
